import React from 'react';
/**
 * Used by Table.Header, Table.Body and Table.HeaderCell.
 * Tells Table.HeaderCell whether it's inside of a Table.Header or a Table.Body.
 * Then, helps sets the appropriate `scope` attribute.
 */

export var TableHeaderCellContext = /*#__PURE__*/React.createContext({
  parent: ''
});
export var TableHeaderCellProvider = TableHeaderCellContext.Provider;